// extracted by mini-css-extract-plugin
export var borderRadius = "_eg-4";
export var large = "_eg-3";
export var logoContainer = "_eg-0";
export var nameLogo = "_eg-2";
export var small = "_eg-1";